import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {range} from 'rxjs';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  standalone: false,
  selector: 'app-circle-progressbar',
  templateUrl: './circle-progressbar.component.html',
  styleUrls: ['./circle-progressbar.component.scss']
})
export class CircleProgressbarComponent implements OnInit {

  @Input() innerCircleWidth = 3;
  @Input() outerCircleWidth = 30;

  private _progress = 0;
  @Input()
  public get progress(): number {
    return this._progress;
  }

  public set progress(value: number) {
    if (value <= 100 && value >= 0) {
      this._progress = value;
      this.updateProgress();
    }
  }

  private _radius: number;
  @Input()
  public get radius(): number {
    return this._radius;
  }

  public set radius(v: number) {
    this._radius = v;

    this.progressRadius = v + (this.innerCircleWidth + this.outerCircleWidth) / 2;
    this.circumference = this.progressRadius * 2 * Math.PI;
    this.dasharray = `${this.circumference} ${this.circumference}`;
    this.updateProgress();
  }

  private progressRadius = this.radius + (this.innerCircleWidth + this.outerCircleWidth) / 2;
  public circumference = this.progressRadius * 2 * Math.PI;
  public offset = this.circumference;
  public offsetChange = new EventEmitter<number>();
  public dasharray = `${this.circumference} ${this.circumference}`;

  ranges: Array<{ start: number; end: number }> = [
    {start: 0, end: 14},
    {start: 15, end: 24},
    {start: 25, end: 34},
    {start: 35, end: 44},
    {start: 45, end: 54},
    {start: 55, end: 64},
    {start: 65, end: 74},
    {start: 75, end: 84},
    {start: 85, end: 94},
    {start: 95, end: 100},
  ];

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
  }

  public getCoinsLink(targetRange: { start: number; end: number }) {
    const link = `/img/source-of-wealth/${this.ranges.indexOf(targetRange)}.svg`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(link);
  }

  public getCoinsVisibility(targetRange: { start: number; end: number }) {
    return this.progress >= targetRange.start && this.progress <= targetRange.end;
  }

  private updateProgress() {
    this.offset = this.circumference - this.progress / 100 * this.circumference;
    this.offsetChange.emit(this.offset);
  }

}
